import * as React from 'react';
import styled from 'styled-components';
import {
  SingleSelect,
  TextInput,
} from '../../../../../widgets/FormikInputFieldV2';
import { ContactCategory, PHONE_TYPE_OPTIONS } from '../../../../../constants';
import { useFormikContext } from 'formik';
import { ContactFormValues } from '../constants';
import 'react-phone-number-input/style.css';
import PhoneNumberInput from '../../../../../widgets/PhoneNumberInput';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const NumberExtContainer = styled.div`
  max-width: 300px;
  display: flex;
  flex-grow: 3;
`;

const ExtContainer = styled.div`
  flex-grow: 1;
  max-width: 80px;
`;

const ExtLabel = styled.label`
  color: gray;
  font-size: 12px;
`;

const TypeContainer = styled.div`
  flex-grow: 1;
  margin-left: 1rem;
  margin-top: 24px;
  align-self: flex-start;
`;

export const PhoneInput: React.FunctionComponent = () => {
  const {
    values: { contactCategory },
  } = useFormikContext<ContactFormValues>();

  const isDL = contactCategory === ContactCategory.DL;

  return (
    <Container>
      <NumberExtContainer>
        <PhoneNumberInput name="primaryNumber" required={!isDL} />
        <ExtContainer>
          <ExtLabel htmlFor="primaryExtensionNumber">Optional Ext.</ExtLabel>
          <TextInput name="primaryExtensionNumber" />
        </ExtContainer>
      </NumberExtContainer>

      <TypeContainer>
        <SingleSelect
          name="primaryNumberType"
          id="selectPrimaryNumberType"
          options={PHONE_TYPE_OPTIONS}
        />
      </TypeContainer>
    </Container>
  );
};
